import React from "react";
import BaseLayout from "../../../components/BaseLayout/BaseLayout";
import { css, cx } from "emotion";
import { useState } from "react";
import AppService from "../../../Services/AppService/AppService";

const FormProperty = () => {
  const user = JSON.parse(localStorage.getItem("user")) || "";
  const [formData, setFormData] = useState({
    mainImageShop: {
      url: "https://malltogo.izy.ai/static/media/img-shop.6b473eb3c587c4fe58c2.jpg",
      name: "",
    },
    mainImageDine: {
      url: "https://malltogo.izy.ai/static/media/img-shop.6b473eb3c587c4fe58c2.jpg",
      name: "",
    },
    imageCornerCard1: {
      url: "https://malltogo.izy.ai/static/media/BANNER-CC.144f7abd7635b6ccc891.webp",
      name: "",
    },
    imageCornerCard2: {
      url: "https://malltogo.izy.ai/static/media/banner-sub-1.f4f0c4af9e3664399077.jpg",
      name: "",
    },
    imageShopCategory1: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory2: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory3: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory4: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory5: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory6: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory7: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageShopCategory8: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageDineCategory1: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageDineCategory2: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageDineCategory3: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    imageDineCategory4: {
      url: "https://assets.izy.ai/img/00046-3742531499-best+quality%2C+masterpiece%2C+otoko+no+ko%2C+short+hair%2C+full+body%2C+blush%2C+testicles%2C+penis%2C+shorts%2C+white+legwear%2C+yaoi%2C+sex%2C+male+f.jpeg",
      name: "",
    },
    vieoUrl: "https://www.youtube.com/watch?v=mfTkQide0Uc",
    title: "",
    description: "",
    errors: {},
    isValid: false,
  });
  const [videoUrl, setvideoUrl] = useState(
    "https://www.youtube.com/watch?v=mfTkQide0Uc"
  );
  console.log(formData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleInputChangeImage = async (event) => {
    const file = event.target.files[0];
    // console.log(event.target);
    const { name } = event.target;
    // console.log(file);
    let imageDataUrl = await readFile(file);
    // let newimage = URL.createObjectURL(file);
    // console.log(newimage);
    // console.log(imageDataUrl);

    // const { formData } = state;
    // formData[name] = imageDataUrl;
    const result = await AppService.uploaderFile({ file: imageDataUrl });
    // console.log(result);
    setFormData({
      ...formData,
      [name]: { url: result.data.url, name: file.name },
    });
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.videoUrl) {
      errors.videoUrl = "Video URL is required";
      isValid = false;
    } else if (!formData.videoUrl.includes("youtube.com")) {
      errors.videoUrl = "Please enter a valid YouTube video URL";
      isValid = false;
    }

    if (!formData.title) {
      errors.title = "Title is required";
      isValid = false;
    }

    if (!formData.description) {
      errors.description = "Description is required";
      isValid = false;
    }

    setFormData({
      ...formData,
      errors: errors,
      isValid: isValid,
    });

    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    console.log(formData);

    // if (validateForm()) {
    //   console.log(formData);
    // }
  };
  console.log(formData);
  return (
    <BaseLayout background="gray">
      <div className="row">
        <div className="col-12 w-100">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-none">
              <li className="breadcrumb-item">
                <a href="/property">Landing Page Setting</a>
              </li>
              {/* <li className="breadcrumb-item active" aria-current="page">
                Landing Page Setting
              </li> */}
            </ol>
          </nav>
          <div className="col-12"></div>
          {/* main image */}
          <div className="card border-0 rounded-8px mt-3 pb-3 mb-3">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Main Image</h3>
            </div>
            <form onSubmit="" className="container w-100">
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                <div className="w-100 ">
                  {/* <img
                    className="img-fluid"
                    src="https://malltogo.izy.ai/static/media/img-shop.6b473eb3c587c4fe58c2.jpg"
                    alt=""
                  /> */}
                  {formData.mainImageShop && (
                    <img
                      className="img-fluid"
                      src={formData.mainImageShop.url}
                      alt=""
                    />
                  )}
                </div>
                <div className="w-100 ">
                  {/* <img
                    className="img-fluid"
                    src="https://malltogo.izy.ai/static/media/img-shop.6b473eb3c587c4fe58c2.jpg"
                    alt=""
                  /> */}
                  {formData.mainImageDine && (
                    <img
                      className="img-fluid"
                      src={formData.mainImageDine.url}
                      alt=""
                    />
                  )}
                </div>
              </div>
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap mt-3"
              >
                <div className=" w-100 p-3">
                  <div className="form-group d-flex flex-column ">
                    <label htmlFor="mainImageShop">Image Shop | 1:1</label>
                    <label htmlFor="mainImageShop">
                      {formData?.mainImageShop?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="mainImageShop"
                      onClick={() =>
                        document.getElementById("input-file").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="input-file"
                      name="mainImageShop"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>

                <div className=" w-100 p-3">
                  <div className="form-group d-flex flex-column ">
                    <label htmlFor="mainImageDine">Image Dine | 1:1</label>
                    <label htmlFor="mainImageDine">
                      {formData?.mainImageDine?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="mainImageShop"
                      onClick={() =>
                        document.getElementById("mainImageDine").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="mainImageDine"
                      name="mainImageDine"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="form-group"> */}
            </form>
          </div>

          {/* video promo */}
          <div className="card border-0 rounded-8px pb-3">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Video Promotion</h3>
            </div>
            <form onSubmit={handleSubmit} className="container w-100">
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                <div className=" embed-responsive embed-responsive-16by9 ">
                  <iframe
                    id="previewVideo"
                    src={`https://www.youtube.com/embed/${
                      videoUrl.split("v=")[1]
                    }`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="embed-responsive-item "
                  />
                </div>
                <div className=" w-100 p-3">
                  <div className="form-group">
                    <label htmlFor="title">Video URL</label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="description">description</label>
                    <input
                      type="text"
                      className="form-control"
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                    {formData.errors.title && (
                      <div className="text-danger">{formData.errors.title}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                    {formData.errors.description && (
                      <div className="text-danger">
                        {formData.errors.description}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="form-group"> */}
            </form>
          </div>
          {/* corner card */}
          <div className="card border-0 rounded-8px mt-3 pb-3">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Cornercard</h3>
            </div>
            <form onSubmit={handleSubmit} className="container w-100">
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                <div className="w-100 ">
                  {/* <img
                    className="img-fluid"
                    src="https://malltogo.izy.ai/static/media/img-shop.6b473eb3c587c4fe58c2.jpg"
                    alt=""
                  /> */}
                  {formData.imageCornerCard1 && (
                    <img
                      className="img-fluid"
                      src={formData.imageCornerCard1.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="form-group d-flex flex-column w-100 container">
                  <label htmlFor="mainImageShop">Image Shop | 1:1</label>
                  <label htmlFor="mainImageShop">
                    {formData?.imageCornerCard1?.name}
                  </label>
                  <div
                    className="btn btn-outline-secondary w-100"
                    name="imageCornerCard1"
                    onClick={() =>
                      document.getElementById("imageCornerCard1").click()
                    }
                  >
                    Choose Image
                  </div>
                  <input
                    type="file"
                    className="form-control"
                    id="imageCornerCard1"
                    name="imageCornerCard1"
                    accept="image/x-png,image/gif,image/jpeg"
                    // value={formData.videoUrl}
                    onChange={handleInputChangeImage}
                    style={{ display: "none" }}
                  />
                  {formData.errors.videoUrl && (
                    <div className="text-danger">
                      {formData.errors.videoUrl}
                    </div>
                  )}
                </div>
              </div>
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap mt-3"
              >
                <div className="w-100 ">
                  {formData.imageCornerCard2 && (
                    <img
                      className="img-fluid"
                      src={formData.imageCornerCard2.url}
                      alt=""
                    />
                  )}
                </div>
                <div className="form-group d-flex flex-column w-100 container">
                  <label htmlFor="imageCornerCard2">Image Shop | 1:1</label>
                  <label htmlFor="imageCornerCard2">
                    {formData?.imageCornerCard2?.name}
                  </label>
                  <div
                    className="btn btn-outline-secondary w-100"
                    name="imageCornerCard2"
                    onClick={() =>
                      document.getElementById("imageCornerCard2").click()
                    }
                  >
                    Choose Image
                  </div>
                  <input
                    type="file"
                    className="form-control"
                    id="imageCornerCard2"
                    name="imageCornerCard2"
                    accept="image/x-png,image/gif,image/jpeg"
                    // value={formData.videoUrl}
                    onChange={handleInputChangeImage}
                    style={{ display: "none" }}
                  />
                  {formData.errors.videoUrl && (
                    <div className="text-danger">
                      {formData.errors.videoUrl}
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="form-group"> */}
            </form>
          </div>
          {/* shop category */}
          <div className="card border-0 rounded-8px mt-3">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Shop Category</h3>
            </div>
            <form onSubmit={handleSubmit} className="container w-100">
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                {/* item 1 */}
                <div className="w-100 ">
                  {formData.imageShopCategory1 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory1.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory1">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory1">
                      {formData?.imageShopCategory1?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory1"
                      onClick={() =>
                        document.getElementById("imageShopCategory1").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory1"
                      name="imageShopCategory1"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 2 */}
                <div className="w-100 ">
                  {formData.imageShopCategory2 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory2.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory2">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory2">
                      {formData?.imageShopCategory2?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory2"
                      onClick={() =>
                        document.getElementById("imageShopCategory2").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory2"
                      name="imageShopCategory2"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 3 */}
                <div className="w-100 ">
                  {formData.imageShopCategory3 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory3.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory3">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory3">
                      {formData?.imageShopCategory3?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory3"
                      onClick={() =>
                        document.getElementById("imageShopCategory3").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory3"
                      name="imageShopCategory3"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 4 */}
                <div className="w-100 ">
                  {formData.imageShopCategory4 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory4.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory4">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory4">
                      {formData?.imageShopCategory4?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory4"
                      onClick={() =>
                        document.getElementById("imageShopCategory4").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory4"
                      name="imageShopCategory4"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* category 2 */}
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                {/* item 1 */}
                <div className="w-100 ">
                  {formData.imageShopCategory5 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory5.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory5">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory5">
                      {formData?.imageShopCategory5?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory5"
                      onClick={() =>
                        document.getElementById("imageShopCategory5").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory5"
                      name="imageShopCategory5"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 2 */}
                <div className="w-100 ">
                  {formData.imageShopCategory6 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory6.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory6">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory6">
                      {formData?.imageShopCategory6?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory6"
                      onClick={() =>
                        document.getElementById("imageShopCategory6").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory6"
                      name="imageShopCategory6"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 3 */}
                <div className="w-100 ">
                  {formData.imageShopCategory7 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory7.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory7">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory7">
                      {formData?.imageShopCategory7?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory7"
                      onClick={() =>
                        document.getElementById("imageShopCategory7").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory7"
                      name="imageShopCategory7"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 4 */}
                <div className="w-100 ">
                  {formData.imageShopCategory8 && (
                    <img
                      className="img-fluid"
                      src={formData.imageShopCategory8.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory8">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory8">
                      {formData?.imageShopCategory8?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory8"
                      onClick={() =>
                        document.getElementById("imageShopCategory8").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory8"
                      name="imageShopCategory8"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap mt-3"
              >
                {/* input item 1 */}
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory1">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory1">
                      {formData?.imageShopCategory1?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory1"
                      onClick={() =>
                        document.getElementById("imageShopCategory1").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory1"
                      name="imageShopCategory1"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>

                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory2">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory2">
                      {formData?.imageShopCategory2?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory2"
                      onClick={() =>
                        document.getElementById("imageShopCategory2").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory2"
                      name="imageShopCategory2"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory3">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory3">
                      {formData?.imageShopCategory3?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory3"
                      onClick={() =>
                        document.getElementById("imageShopCategory3").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory3"
                      name="imageShopCategory3"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory4">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory4">
                      {formData?.imageShopCategory4?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory4"
                      onClick={() =>
                        document.getElementById("imageShopCategory4").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory4"
                      name="imageShopCategory4"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap mt-3"
              >
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory5">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory5">
                      {formData?.imageShopCategory5?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory5"
                      onClick={() =>
                        document.getElementById("imageShopCategory5").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory5"
                      name="imageShopCategory5"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>

                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory6">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory6">
                      {formData?.imageShopCategory6?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory6"
                      onClick={() =>
                        document.getElementById("imageShopCategory6").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory6"
                      name="imageShopCategory6"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory7">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory7">
                      {formData?.imageShopCategory7?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory7"
                      onClick={() =>
                        document.getElementById("imageShopCategory7").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory7"
                      name="imageShopCategory7"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageShopCategory8">Image Shop | 1:1</label>
                    <label htmlFor="imageShopCategory8">
                      {formData?.imageShopCategory8?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageShopCategory8"
                      onClick={() =>
                        document.getElementById("imageShopCategory8").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageShopCategory8"
                      name="imageShopCategory8"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="form-group"> */}
            </form>
          </div>

          {/* dine category */}
          <div className="card border-0 rounded-8px mt-3 mb-3">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Dine Category</h3>
            </div>
            <form onSubmit={handleSubmit} className="container w-100 ">
              {/* category 2 */}
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap"
              >
                {/* item 1 */}
                <div className="w-100 ">
                  {formData.imageDineCategory1 && (
                    <img
                      className="img-fluid"
                      src={formData.imageDineCategory1.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory1">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory1">
                      {formData?.imageDineCategory1?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory1"
                      onClick={() =>
                        document.getElementById("imageDineCategory1").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory1"
                      name="imageDineCategory1"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 2 */}
                <div className="w-100 ">
                  {formData.imageDineCategory2 && (
                    <img
                      className="img-fluid"
                      src={formData.imageDineCategory2.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory2">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory2">
                      {formData?.imageDineCategory2?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory2"
                      onClick={() =>
                        document.getElementById("imageDineCategory2").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory2"
                      name="imageDineCategory2"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 3 */}
                <div className="w-100 ">
                  {formData.imageDineCategory3 && (
                    <img
                      className="img-fluid"
                      src={formData.imageDineCategory3.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory3">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory3">
                      {formData?.imageDineCategory3?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory3"
                      onClick={() =>
                        document.getElementById("imageDineCategory3").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory3"
                      name="imageDineCategory3"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                {/* item 4 */}
                <div className="w-100 ">
                  {formData.imageDineCategory4 && (
                    <img
                      className="img-fluid"
                      src={formData.imageDineCategory4.url}
                      alt=""
                    />
                  )}
                </div>

                <div className="d-md-none w-100">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory4">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory4">
                      {formData?.imageDineCategory4?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory4"
                      onClick={() =>
                        document.getElementById("imageDineCategory4").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory4"
                      name="imageDineCategory4"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-between 
              flex-wrap flex-sm-nowrap mt-3 pb-3"
              >
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory1">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory1">
                      {formData?.imageDineCategory1?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory1"
                      onClick={() =>
                        document.getElementById("imageDineCategory1").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory1"
                      name="imageDineCategory1"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>

                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory2">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory2">
                      {formData?.imageDineCategory2?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory2"
                      onClick={() =>
                        document.getElementById("imageDineCategory2").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory2"
                      name="imageDineCategory2"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory3">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory3">
                      {formData?.imageDineCategory3?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory3"
                      onClick={() =>
                        document.getElementById("imageDineCategory3").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory3"
                      name="imageDineCategory3"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
                <div className=" w-100 p-3 d-md-block d-none">
                  <div className="form-group d-flex flex-column w-100 container">
                    <label htmlFor="imageDineCategory4">Image Shop | 1:1</label>
                    <label htmlFor="imageDineCategory4">
                      {formData?.imageDineCategory4?.name}
                    </label>
                    <div
                      className="btn btn-outline-secondary w-100"
                      name="imageDineCategory4"
                      onClick={() =>
                        document.getElementById("imageDineCategory4").click()
                      }
                    >
                      Choose Image
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      id="imageDineCategory4"
                      name="imageDineCategory4"
                      accept="image/x-png,image/gif,image/jpeg"
                      // value={formData.videoUrl}
                      onChange={handleInputChangeImage}
                      style={{ display: "none" }}
                    />
                    {formData.errors.videoUrl && (
                      <div className="text-danger">
                        {formData.errors.videoUrl}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="form-group"> */}
            </form>
          </div>
          <div className="d-flex mb-3 align-items-end bg-warning">
            <div>
              <button type="btn" className="btn btn-danger m-2">
                Cancel
              </button>
              <button
                type="btn"
                onClick={handleSubmit}
                className="btn btn-success m-2"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default FormProperty;
